<template>
	<div class="contact-page">
		<section>
			<ContactForm />
		</section>
	</div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
@import '~/assets/design';

.contact-page {
	width: 100%;
	max-width: 560px;
	min-height: calc(100vh - 366px);
	padding: 0 15px;
	margin: 0 auto;
	margin-top: 50px;
}
</style>
